import React from 'react'

const Notifications:React.FC = () => {
  return (
    <div>Notifications</div>
  )
}

export default Notifications